import React from 'react';
import { Box, Container, Typography, Stack, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import MuseumRoundedIcon from '@mui/icons-material/MuseumRounded';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        borderTop: '1px solid rgba(109, 232, 255, 0.16)',
        background: 'linear-gradient(112deg, rgba(4,10,27,0.97), rgba(8,14,35,0.96) 42%, rgba(12,20,48,0.97))',
        color: '#9fb4d6',
      }}
    >
      <Container maxWidth="lg" sx={{ py: { xs: 3.5, sm: 4.5 } }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 2, sm: 3 }}
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          justifyContent="space-between"
        >
          <Stack direction="row" spacing={1.2} alignItems="center">
            <MuseumRoundedIcon sx={{ color: '#6de8ff', fontSize: 26 }} />
            <Box>
              <Typography sx={{ color: '#eaf7ff', fontWeight: 700, fontFamily: '"Sora", sans-serif', lineHeight: 1.2, fontSize: '0.95rem' }}>
                Museo Digital 3D
              </Typography>
              <Typography sx={{ fontSize: '0.72rem', color: '#7f93b3' }}>
                Patrimonio cultural en Realidad Aumentada
              </Typography>
            </Box>
          </Stack>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 0.5, sm: 3 }}>
            <MuiLink component={Link} to="/" underline="hover" sx={{ color: '#c4d9f5', fontSize: '0.82rem', fontWeight: 600 }}>
              Colección
            </MuiLink>
            <MuiLink component={Link} to="/geoscenes" underline="hover" sx={{ color: '#c4d9f5', fontSize: '0.82rem', fontWeight: 600 }}>
              Escenas Geo
            </MuiLink>
            <MuiLink component={Link} to="/login" underline="hover" sx={{ color: '#c4d9f5', fontSize: '0.82rem', fontWeight: 600 }}>
              Acceso Admin
            </MuiLink>
          </Stack>
        </Stack>

        <Box sx={{ mt: 3, pt: 2.5, borderTop: '1px solid rgba(133, 201, 255, 0.12)' }}>
          <Typography sx={{ fontSize: '0.75rem', color: '#7f93b3', textAlign: { xs: 'left', sm: 'center' } }}>
            © {new Date().getFullYear()} Museo Digital 3D. Desarrollado por{' '}
            <MuiLink href="#" sx={{ color: '#9fd6f0' }} underline="hover">
              Suriyaco Valley
            </MuiLink>{' '}
            — La Rioja, Argentina.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
